import { LoadableBackground } from '@confluence/loadable';

export { EditorHelpCenter } from './editor-help-center';

export { HelpMenuClassicContext, HelpMenuContextProvider, HelpMenu } from './editor-help-menu';

export const HelpManagerLoader = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-HelpManager" */ './HelpManager')).HelpManager,
});
